export default __webpack_public_path__ + "static/formImage-28c551d4d6d6cc651f1bb1204c908c6c.png";